import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import OrgCard from '../../components/OrgCard'
import { useNavigate } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { FaPlus } from 'react-icons/fa'

const Member = () => {
    const [organizations, setOrganizations] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    const navigate = useNavigate()

    const getUserOrgs = async (currentPage) => {
        try {
            setIsLoading(true)
            const response = await api.get(`/organizations/member?page=${currentPage}`)
            // console.log(response)
            const newData = response.data || []

            setOrganizations(prev => [...prev, ...newData])
            setHasMore(newData.length > 0) 
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setHasMore(false)
            toast.error(error?.response?.data?.message || 'Failed to fetch organizations')
        }
        finally{
            setHasMore(false)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getUserOrgs(page)
    }, [page])

    return (
        <div className='orgpage-body'>
            <div className="orglist-page-header">
                <h2 className='page-title'>Joined as a member</h2>
                <button className='centered-content' onClick={() => navigate("/organizations/suggested")}>
                    <FaPlus />
                </button>
            </div>
            <div className="org-list-container">
                {organizations.length === 0 && !isLoading && (
                    <p className="not-found-msg">No organizations found</p>
                )}
                <InfiniteScroll
                    dataLength={organizations.length}
                    next={() => setPage(prev => prev + 1)}
                    hasMore={hasMore}
                    loader={<Loader />}
                >
                    {
                        organizations.map((org) => (
                            <OrgCard org={org.organization} key={org.organization._id} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default Member
